import { CategoryIcon } from '@modules/common/components/CategoryIcon';
import { SetSelectedLabels } from '@modules/feedback/types';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { Category } from '@modules/common/types';
import { capitalize } from 'lodash';
import { Feedback, FeedbackLabel } from 'v2/core/entities/feedback';
import { FeedbackLabelV2 } from '../FeedbackLabelV2';

interface FeedbackTruncatedLabelsTooltipContentProps {
  category: Category;
  feedback: Feedback;
  selectedLabels: FeedbackLabel[];
  remainingLabels: FeedbackLabel[];
  setSelectedLabels?: SetSelectedLabels;
  isLabelsSelectionDisabled?: boolean;
  onFeedbackCardLabelClick?: (selectedLabels: FeedbackLabel[]) => void;
  disableLabelSelection?: boolean;
  disabledLabelIDs?: string[];
}

export const FeedbackTruncatedLabelsTooltipContent = ({
  category,
  feedback,
  remainingLabels,
  setSelectedLabels,
  selectedLabels,
  isLabelsSelectionDisabled,
  onFeedbackCardLabelClick,
  disableLabelSelection,
  disabledLabelIDs,
}: FeedbackTruncatedLabelsTooltipContentProps) => {
  const renderTooltipLabels = () => {
    return remainingLabels?.map((label) => {
      const isSelected = selectedLabels.indexOf(label) > -1;

      return (
        <Box
          sx={{
            pointerEvents: isLabelsSelectionDisabled ? 'none' : 'auto',
          }}
          key={label.id}
        >
          <FeedbackLabelV2
            label={label}
            setSelectedLabels={setSelectedLabels}
            selectedLabels={selectedLabels}
            isSelected={isSelected}
            feedback={feedback}
            category={category}
            isDisabled={
              disableLabelSelection || disabledLabelIDs?.includes(label.id)
            }
            onFeedbackCardLabelClick={onFeedbackCardLabelClick}
            size="small"
          />
        </Box>
      );
    });
  };

  return (
    <Stack component={Paper} spacing={2} p={2} elevation={24}>
      <Stack direction="row" spacing={0.5} alignItems="center">
        <CategoryIcon category={category} size={14} />
        <Typography variant="body2">{capitalize(category)}</Typography>
      </Stack>
      <Stack direction="row" gap={1} flexWrap="wrap">
        {renderTooltipLabels()}
      </Stack>
    </Stack>
  );
};
